import type { components } from '@/generated/contracts/api-v1';
import { v1, toResult } from '@/infrastructure/api/v1/client';
import { ScreenRead } from '@/infrastructure/api/v1/screenReads';

export type StoryWorkspaceDto = components['schemas']['StoryWorkspaceDto'];

/**
 * The story edit page in one read (getStoryWorkspace): the story, its versions, its project, its images, the template
 * it has produced and, for its owner, its share links. The page's data hook reads it; the template status takes its
 * part of the same answer for its first read.
 */
export const storyWorkspace = new ScreenRead<StoryWorkspaceDto>();

export const readStoryWorkspace = (storyId: string) =>
  storyWorkspace.read(storyId, () => toResult(v1.GET('/api/v1/stories/{storyUniqueId}/workspace', { params: { path: { storyUniqueId: storyId } } })));
